import React from 'react'
import { useSortable } from '@dnd-kit/sortable'
import './sortable-item.css'
import { AlphaTypes } from '../../custom-types'

interface SortableItemProps {
  id: string
  item: AlphaTypes
  renderItem: (id: AlphaTypes) => React.ReactNode
}

export const SortableItem = ({ id, item, renderItem }: SortableItemProps) => {
  const { attributes, listeners, setNodeRef, isDragging } = useSortable({ id })

  return (
    <div
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      className={`sortable-item ${isDragging ? 'is-dragging' : ''}`}
      data-id={id}
    >
      {renderItem(item)}
    </div>
  )
}
